import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { Task } from '../task/Task'
import type { ProjectStatusEnum } from './ProjectStatusEnum'
import { Activity } from '../activity/Activity'
import { RelatedEntity } from '../base/RelatedEntity'
import { WorkOrder } from '../work-order/WorkOrder'
import { Asset } from '../asset/Asset'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProjectInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class Project extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('proj') })
  declare _id: string

  @Field(() => [Task])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  tasks: ReturnType<() => Task[]>

  @Field(() => Float)
  @Prop({ type: Number })
  timeSpent: number

  @Field(() => String)
  @Prop({ type: String })
  declare status: ProjectStatusEnum

  @Field(() => [Activity])
  @Prop({ type: [Activity] })
  remarksActivity: Activity[]

  @Field(() => [Project])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedProjects: ReturnType<() => Project[]>

  @Field(() => [WorkOrder])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedWorkOrders: ReturnType<() => WorkOrder[]>

  @Field(() => Float)
  @Prop({ type: Number })
  progressNow: number

  @Field(() => Float)
  @Prop({ type: Number })
  progressMax: number

  @Field(() => Date)
  @Prop({ type: Date })
  completionDate: Date

  @Field(() => [Asset])
  @Prop({ type: [Asset] })
  assets: Asset[]
}
